import { toast } from "react-toastify";
import { chainData } from "./chains.js"
import { newnd721 } from "./abi/NDNFTFactory_new.js"
import { ethers } from 'ethers'
import { cleanUrl, ipfs2md5, stripFile } from "./utils/index.js";
import * as imageConversion from "image-conversion";
import { uploadToCache, uploadItem } from "./lib/api";

/**
 * UploadManager - in-memory upload/NFT fetch queues with reactive side-effects.
 *
 * Replaces the old global `window.uploadItems`, `window.nftFetcher`,
 * `window.targetProxy`, and `window.targetProxy_nft`.
 *
 * Consumers should use `uploadManager.uploadQueue.push(...)` and
 * `uploadManager.nftQueue.push(...)` instead of touching `window.*`.
 */

type UploadItem = any;
type NftItem = any;

const uploadQueue: UploadItem[] = [];
const nftQueue: NftItem[] = [];

let isProcessing = false;
let isProcessing_NFT = false;
let currentPosition = 0;
let addItemToast: any = null;
let uploadDoneToast: any = null;
let addedItemsCount = 0;
let currentPosition_NFT = 0;
let addItemToast_NFT: any = null;
let uploadDoneToast_NFT: any = null;
let addedItemsCount_NFT = 0;

function onUploadAdded() {
  if (addItemToast == null) {
    addedItemsCount++;
    //addItemToast = toast(`Added item to the upload queue`, { autoClose: 1500 });
  } else {
    addedItemsCount++;
    //toast.update(addItemToast, { render: () => 'Added ' + addedItemsCount + ' items to the upload queue', autoClose: 1500 });
  }
  processQueue();
}

function onNftAdded() {
  if (addItemToast_NFT == null) {
    addedItemsCount_NFT++;
    //addItemToast_NFT = toast(`Added item to the NFT queue`, { autoClose: 1500 });
  } else {
    addedItemsCount_NFT++;
    //toast.update(addItemToast_NFT, { render: () => 'Added ' + addedItemsCount_NFT + ' items to the NFT queue', autoClose: 1500 });
  }
  processNFTs();
}

export const uploadManager = {
  get uploadQueue() {
    return uploadQueue;
  },
  get nftQueue() {
    return nftQueue;
  },
};

const uploadProxy = new Proxy(uploadQueue, {
  set(_target, key, value) {
    if (key !== 'length') {
      (uploadQueue as any)[key] = value;
      setTimeout(onUploadAdded, 0);
    }
    return true;
  },
});

const nftProxy = new Proxy(nftQueue, {
  set(_target, key, value) {
    if (key !== 'length') {
      onNftAdded();
      (nftQueue as any)[key] = value;
    }
    return true;
  },
});

export const UploadShim = async () => {
  uploadQueue.length = 0;
  nftQueue.length = 0;
};

const processNFTs = async () => {
  if (isProcessing_NFT === false) {
    let progress = 0;
    isProcessing_NFT = true;
    let errs = 0;
    for (let i = 0; i < nftProxy.length; i++) {
      const JsonData = nftProxy[i];
      let lastCount, lastPos;
      if (JsonData?.getMeta) {
        getNFT(JsonData);
      }
      let result = null;
      if (result !== null) {
        if (result?.err) errs++;
        const CustomToast = (data: any) => {
          let buf: any[] = [];
          Object.entries(result).forEach(([key, value]) => {
            if (key !== "__length__" && !parseInt(key) && key !== "0" && (key === "info" || key === "message")) {
              buf.push(value);
            }
          });
          return (<div style={{width: "300px"}}>
            {data}<br/>{buf.map((item: any) => <div key={item}>{item}</div>)}
          </div>);
        };
        if (uploadDoneToast_NFT == null) {
          currentPosition_NFT++;
          lastPos = currentPosition_NFT;
          lastCount = nftProxy.length;
          progress = lastPos / lastCount;
          const prog = progress === 1 ? { autoClose: 3500 } : { progress: progress };
          //uploadDoneToast_NFT = toast.info(CustomToast("Item " + lastPos + " of " + lastCount), prog);
        } else {
          currentPosition_NFT++;
          lastPos = currentPosition_NFT;
          lastCount = nftProxy.length;
          progress = lastPos / lastCount;
          const deets = "Item " + lastPos + " of " + lastCount;
          const data: any = {
            render: () => CustomToast(deets),
            progress: progress,
          };
          if (lastPos === lastCount) {
            delete data["progress"];
            data.autoClose = 3500;
          }
          //toast.update(uploadDoneToast_NFT, data);
        }
      }
    }
    nftQueue.length = 0;
    currentPosition_NFT = 0;
    addItemToast_NFT = null;
    uploadDoneToast_NFT = null;
    addedItemsCount_NFT = 0;
    isProcessing_NFT = false;
    if (errs > 0) {
      toast("Uploads finished, failures: " + errs, { autoClose: 60000 });
    }
  }
};

async function getNFT(JsonData: any) {
  try {
    let js: any = {};
    let img: any;
    if (!JsonData?.data?.meta?.image) {
      const prov = new ethers.providers.JsonRpcProvider(chainData[JsonData?.net].rpc);
      const ctr = new ethers.Contract(JsonData?.ctrAddr, newnd721, prov);
      await ctr.deployed();
      const turi = await ctr.tokenURI(JsonData?.tokenId);
      const bob = await fetch("https://nftstorage.link" + cleanUrl(turi, false))
      js = await bob.json();
    } else {
      js = JsonData.data.meta;
    }
    if (js?.image) {
      const _bob = await fetch("https://nftstorage.link" + cleanUrl(js.image, false));
      img = await _bob.blob();
      const file = new File([img], JsonData.target, { type: "image/png", lastModified: Date.now() });
      const reader = new FileReader();
      reader.onloadend = async () => {
        const targetImg = document.getElementById(JsonData?.target);
        if (targetImg) {
          targetImg.src = reader.result;
        }
        const uld: any = {};
        uld.imageFile = reader.result;
        uld.image = js.image;
        const item: any = {};
        item.id = JsonData?.tokenId;
        let fimg = js.image;
        if (js.image.includes("ipfs://")) fimg = "https://nftstorage.link" + cleanUrl(js.image, false);
        await cacheImage(fimg, JsonData.cDat, item, null);
      };
      reader.readAsDataURL(file);
    }
  } catch (e) {
    // ignore
  }
}

const sendToServer = async (_nftData: any) => {
  // reserved
};

async function cacheImage(r: string, d: any, i: any, _e: any) {
  const cDat = d;
  const item = i;
  await fetch(r)
    .then(res => res.blob())
    .then(async blob => {
      const file = new File([blob], r.replace(stripFile(r)), blob);
      try {
        let divisor = 0.8;
        if (file.type === "image/jpeg") {
          divisor = 0.7;
        }
        if (file?.size < 70000) {
          divisor = 1;
        }
        if (file?.size > 500000) {
          divisor = 0.4;
        }
        const targetSize = Math.floor((file?.size / 2048) * divisor);
        const clampedTargetSize = targetSize > 500 ? 500 : targetSize;
        imageConversion.compressAccurately(file, {
          size: clampedTargetSize,
          accuracy: 0.9,
          type: "image/jpeg",
        }).then(async res => {
          try {
            const nimg = await imageConversion.filetoDataURL(res);
            const upload = {
              collID: cDat?.id,
              edition: item?.id,
              cachefn: ipfs2md5(cleanUrl(r, false), false),
              clean: cleanUrl(r, false),
              imageFile: nimg.split(";base64,")[1],
            };
            await uploadToCache({ upload }).catch(err => {
              console.error('Cache upload failed:', err);
            });
          } catch (err) {
            // ignore
          }
        }).catch((err) => { console.log("AddtoCache: "); });
      } catch (e) {
        // ignore
      }
    });
}

const processQueue = async () => {
  if (isProcessing === false) {
    let progress = 0;
    isProcessing = true;
    let errs = 0;
    for (let i = 0; i < uploadProxy.length; i++) {
      const JsonData = uploadProxy[i];
      let lastCount, lastPos;
      try {
        const result = await uploadItem(JsonData);
        if (result?.err) errs++;
        const CustomToast = (data: any) => {
          let buf: any[] = [];
          Object.entries(result).forEach(([key, value]) => {
            if (key !== "__length__" && !parseInt(key) && key !== "0" && (key === "info" || key === "message")) {
              buf.push(value);
            }
          });
          return (<div style={{ width: "300px" }}>
            {data}<br/>{buf.map((item: any) => <div key={item}>{item}</div>)}
          </div>);
        };
        if (uploadDoneToast == null) {
          currentPosition++;
          lastPos = currentPosition;
          lastCount = uploadProxy.length;
          progress = lastPos / lastCount;
          const prog = progress === 1 ? { autoClose: 3500 } : { progress: progress };
          uploadDoneToast = toast.info(CustomToast("Item " + lastPos + " of " + lastCount), prog);
        } else {
          currentPosition++;
          lastPos = currentPosition;
          lastCount = uploadProxy.length;
          progress = lastPos / lastCount;
          const deets = "Item " + lastPos + " of " + lastCount;
          const data: any = {
            render: () => CustomToast(deets),
            progress: progress,
          };
          if (lastPos === lastCount) {
            delete data["progress"];
            data.autoClose = 3500;
          }
          toast.update(uploadDoneToast, data);
        }
      } catch (error) {
        console.error('Upload error:', error);
        errs++;
      }
    }
    uploadQueue.length = 0;
    currentPosition = 0;
    addItemToast = null;
    uploadDoneToast = null;
    addedItemsCount = 0;
    isProcessing = false;
    if (errs > 0) {
      toast("Uploads finished, failures: " + errs, { autoClose: 60000 });
    }
  }
};

export { uploadProxy, nftProxy };
